<template>
	<div>
		<a-row class="">
			<div class="flex mt15 mb15" style="justify-content: space-between;">
                <div class="flex items-center">
                    <img class="ml15 mr10" src="../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                    <div class="ml0 fs14" style="color:grey">业主确认单</div>
                </div>
                <div class="mr20 flex" style=""> 
                    <a-input-search allowClear class="" v-model="search" placeholder="请输入关键字" enter-button @change="allowCostClear" @search="onSearch" @pressEnter="onSearch"/>
                    <!-- <a-button class="ml10" style="background-color: red;color: white;" icon="sync" @click="">
                        导出
                    </a-button> -->
                    <a-button class="ml10" style="background-color: #fd6363;color: white;" icon="plus" @click="addOwersConfirm">
                        新增
                    </a-button>
                </div>
            </div>
		</a-row>
		
		<a-row :gutter="24" type="flex" align="stretch">
			<a-col :span="24" :lg="30" class="mb-24">
				<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
					<a-table :data-source="data" :columns="columns" class="pd15" :pagination="false" size="small" bordered>
                        <template slot="name" slot-scope="text,record">
                            <a @click="goCheckDetail(record.id)">{{ text }}</a>	
                        </template>
                        <template slot="amount" slot-scope="text,record">
                            <div>{{ record.proceeds_amount/100 }}</div>	
                        </template>
                        <!-- <template slot="attachment">
                            <div class="fs12">见详情页</div>	
                        </template> -->
                        <template slot="operation" slot-scope="text,record">
                            <!-- <a @click="goEditDetail(record.id)">编辑</a>	 -->
                            <a-popconfirm ok-text="确定" cancel-text="取消" title="确认删除？" @confirm="() => goDeleteDetail(record.key)">
                                <a class="ml10">删除</a>
                            </a-popconfirm>	
                        </template>
					</a-table>
					<a-pagination 
						class="flex items-center mb10"
						style="justify-content: flex-end"
						show-quick-jumper  
						v-model="page.page" 
						:total="page.total" 
						@change="onShowSizeChange" 
					/>
				</a-card>
			</a-col>
		</a-row>
		<a-drawer
			title="新增业主确认单·默认业务类型"
			:width="1200"
			:visible="visibleAddPlan"
			:body-style="{ paddingBottom: '80px' }"
			@close="onClose()"
		>
            <div>
                <a-form :form="form" layout="vertical" hide-required-mark>
                    <a-row :gutter="16" class="">
                        <a-col :span="12">
                            <a-form-item label="收款类型">
                                <a-input
                                    v-model="newConfirm.name"
                                    placeholder="请选择收款类型"
                                    style="width:300px"
                                    :disabled="true"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12" >
                            <a-form-item label="项目名称" >
                                <a-select
                                    label-in-value
                                    show-search
                                    v-model="selectProject"
                                    option-filter-prop="children"
                                    :filter-option="filterOption"
                                    style="width: 300px"
                                    placeholder="请选择项目"
                                    @change="updateProjectSelect"
                                > 
                                <a-select-option v-for="item in projectList" :key="item.id">
                                    {{ item.name }} —— {{ item.create_time.substring(0,10)}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="">
                        <a-col :span="12">
                            <a-form-item label="金额">
                                <a-input-number
                                    :min="0" 
                                    v-model="newConfirm.amount"
                                    placeholder="重计量预算总额（含税）"
                                    :step="0.01"
                                    style="width:300px"

                                />
                            </a-form-item>
                        </a-col>
                       
                    </a-row>
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="备注">
                                <a-textarea
                                    v-model="newConfirm.note"
                                    placeholder="请输入备注"
                                    :auto-size="{ minRows: 3, maxRows: 5 }"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="">
                        <a-col :span="12">
                            <a-form-item label="附件">
                                <a-upload
                                    :action="upload_url"
                                    :before-upload="beforeUpload"
                                    class="upload-list-inline"
                                    @change="handleChange"
                                    :headers="headers"
                                >
                                    <!-- <div v-for="(item,index) in newConfirm.attachment" :key="index">
                                        {{index}} + {{item}}
                                    </div> -->
                                    <a-button> <a-icon type="upload" /> 上传 </a-button>
                                </a-upload>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    
                </a-form>
            </div>
			<div
				:style="{
					position: 'absolute',
					right: 0,
					bottom: 0,
					width: '100%',
					borderTop: '1px solid #e9e9e9',
					padding: '10px 16px',
					background: '#fff',
					textAlign: 'right',
					zIndex: 1,
				}"
			>
				<a-button :style="{ marginRight: '8px' }" @click="onClose()">
					取消
				</a-button>
				<a-button type="primary" @click="goAddOwersConfirm">
					保存
				</a-button>
			</div>
		</a-drawer>
        <a-drawer
            :width="1200"
            :visible="visibleCheck"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose()"
        >
            <div class="flex items-center mt20">
                <div class="flex">
                    <div class="flex">
                        <img class="mr10" src="../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                        <div class="fs16" style="font-weight: bolder;">{{ newConfirm.name }}</div>
                        <div class="ml20 mt2 fs14" style="color:grey">结算款</div>
                    </div>
                </div>
                <div class="flex items-center" style="position: absolute;right:0">
                    <!-- <a-button @click="visibleCheck = false">关闭</a-button> -->
                    <!-- <a-button class="ml10" style="background-color: red;color: white;" @click="">打印</a-button> -->
                </div>
            </div>

            <a-divider />

            <a-tabs>
                <a-tab-pane tab="详情" :key="1">
                    <div>
                        <div>
                            <a-row :gutter="16" class="fs16 mt20">
                                <!-- <a-col :span="12">
                                    <div style="color:grey">主题</div>
                                    <div>{{((newConfirm.name != "")&&(newConfirm.name != null))?newConfirm.name:"--"}}</div>
                                </a-col> -->
                                <a-col :span="12">
                                    <div style="color:grey">项目名称</div>
                                    <div>{{((newConfirm.project_name != "")&&(newConfirm.project_name != null))?newConfirm.project_name:"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div style="color:grey">总金额</div>
                                    <div>{{((newConfirm.proceeds_amount != "")&&(newConfirm.proceeds_amount != null))?newConfirm.proceeds_amount/100:"--"}}</div>
                                </a-col>
                            
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div style="color:grey">备注</div>
                                    <div>{{((newConfirm.note != "")&&(newConfirm.note != null))?newConfirm.note:"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div style="color:grey">附件</div>
                                    <div v-if="newConfirm.attachment.length != 0">
                                        <div v-for="(item, index) in newConfirm.attachment" :key="index">{{ item }}</div>
                                    </div>
                                    <div v-else>--</div>
                                </a-col>
                            </a-row>
                        </div>
                        <a-divider />
                        <div>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div style="color:grey">创建人</div>
                                    <div>{{((newConfirm.create_person != "")&&(newConfirm.create_person != null))?newConfirm.create_person:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div style="color:grey">创建时间</div>
                                    <div>{{((newConfirm.create_time != "")&&(newConfirm.create_time != null))?newConfirm.create_time.replace("T", " "):"--"}}</div>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                </a-tab-pane>
            </a-tabs>
            
        
        </a-drawer>
	
	</div>
</template>

<script>
const KF = 'updatable';
	export default ({
		components: {

		},
		data() {
			return {
                form: this.$form.createForm(this),
				columns:[
					{
                        title: '序号',
                        dataIndex: 'id',
                        key: 'id',
                    },
                    // {
                    //     title: '主题',
                    //     dataIndex: 'name',
                    //     key: 'name',
                    //     scopedSlots: { customRender: 'name' },
                    // },
                    {
                        title: '项目名称',
                        dataIndex: 'project_name',
                        key: 'project_name',
                    },
                    {
                        title: '总金额',
                        dataIndex: 'amount',
                        key: 'amount',
                        scopedSlots: { customRender: 'amount' },
                    },
                    {
                        title: '备注',
                        dataIndex: 'note',
                        key: 'note',
                    },
                    // {
                    //     title: '附件',
                    //     dataIndex: 'attachment',
                    //     key: 'attachment',
                    //     scopedSlots: { customRender: 'attachment' },
                    // },
                    {
                        title: '创建人',
                        dataIndex: 'create_person',
                        key: 'create_person',
                    },
					{
                        title: '操作',
                        dataIndex: 'operation',
                        key: 'operation',
                        scopedSlots: { customRender: 'operation' },
                    },
				],
				data:[],
				page:{page:1,total:0},
				search:"",
				visibleAddPlan:false,
                visibleCheck:false,
				newConfirm:{id:0, name:"业主确认单",project_id:0, project_name:"",amount:0, attachment:[], note:"", create_person_id:0, create_person:""},
				selectProject:{key:0, label:""},
                projectList:[],
                upload_url: "",
				headers: {},
                fileList:[],

			}
		},
		created(){
            this.upload_url = this.$api.request_body.url + "/project/upload_assets";
			this.headers.token = this.$api.request_body.token;
			this.getOwersConfirmRecord()
            this.getProjectList()
		},
		methods:{
			async getOwersConfirmRecord(){
				let rs = await this.$api.getOwersConfirmRecord(this.search, this.page.page - 1, 10)
                console.log(rs.data)
				if(rs.err == 0){
                    for(let item of rs.data){
                        item.amount = item.amount/100
                    }
					this.data = rs.data
					this.page.total = rs.count
				}
			},
            async getProjectList(){
                let rs = await this.$api.getProjectList()
                if(rs.err == 0){
                    this.projectList = rs.data
                }
            },
			onSearch(){
				if((this.search.length == 0)){
                    this.$notification['warning']({
                        message: '查询条件为空',
                        description:
                        '请输入查询关键词',
                        style: {
                            width: '600px',
                            marginLeft: `${335 - 600}px`,
                        },
                    });
                    return;
                } else {
					this.getOwersConfirmRecord()
                }
			},
			onShowSizeChange(){
				if(this.search.length != 0){
                    this.onSearch()
                }else{
					this.page.page = 1
                    this.getOwersConfirmRecord()
                }
			},
            async getOwersConfirmDetail(key){
                let rs = await this.$api.getOwersConfirmDetail(key)
                this.fileList = []
                if(rs.err == 0){
                    let as = {}
                    as.id = rs.data[0].id
                    as.name = rs.data[0].name
                    as.project_id = rs.data[0].project_id
                    as.project_name = rs.data[0].project_name
                    as.create_person = rs.data[0].create_person
                    as.create_time = rs.data[0].create_time
                    as.amount = rs.data[0].amount/100
                    as.note = rs.data[0].note
                    as.attachment = []

                    if(rs.data.length > 1){
                        for(let item of rs.data){
                            if((item.attach_url != null)&&(item.attach_url != "")){
                                as.attachment.push(item.attach_url)
                                let bs = {}
                                bs.uid = this.fileList.length + 1
                                bs.name = item.attach_url
                                bs.status = "done"
                                bs.url = item.attach_url
                                this.fileList.push(bs)
                            }
                        }
                    }
                    this.selectProject.key = rs.data[0].project_id 
                    this.selectProject.label = rs.data[0].project_name
                    this.newConfirm = as
                }
            },
		    async goCheckDetail(key){
                this.getOwersConfirmDetail(key)
                this.visibleCheck = true
            },
            async goEditDetail(key){
                this.getOwersConfirmDetail(key)
                this.visibleAddPlan = true
            },
            goDeleteDetail(key){
                this.data = this.data.filter(it=> it.key != key)
            },
			addOwersConfirm(){
                let aa = {}
                aa.id = 0
                aa.name = "业主确认单", 
                aa.project_id = 0, 
                aa.project_name = "", 
                aa.amount = 0,
                aa.attachment = [], 
                aa.create_person_id = 0, 
                aa.create_person = "",
                this.newConfirm = aa
				this.visibleAddPlan = true;
			},
			async goAddOwersConfirm(){
                console.log(this.newConfirm)
                if(this.newConfirm.project_id == 0){
                    this.$notification['warning']({
                        message: '未选择项目',
                        style: {
                            width: '600px',
                            marginLeft: `${335 - 600}px`,
                        },
                    });
                    return;
                }
                // if(this.newConfirm.name.length == 0){
                //     this.$notification['warning']({
                //         message: '主题未填写',
                //         style: {
                //             width: '600px',
                //             marginLeft: `${335 - 600}px`,
                //         },
                //     });
                //     return;
                // }
                if(this.newConfirm.amount == 0){
                    this.$notification['warning']({
                        message: '金额不能为0',
                        style: {
                            width: '600px',
                            marginLeft: `${335 - 600}px`,
                        },
                    });
                    return;
                }
                let rs = await this.$api.goAddOwersConfirm(this.newConfirm)
                if(rs.err == 0){
                    this.$message.success('保存成功')
                    this.visibleAddPlan = false
                    this.getOwersConfirmRecord()
                }else{
                    this.$message.warn('保存失败，请检查后重试或联系管理员')
                }
			},
			allowCostClear(){
                if(this.search.length == 0){
                    this.page.page = 1;
                    this.getOwersConfirmRecord()
                }
            },
			onClose(){
				this.visibleAddPlan = (this.visibleAddPlan)?false:false
				this.visibleCheck = (this.visibleCheck)?false:false
			},
            updateProjectSelect(){
                this.newConfirm.project_id = this.selectProject.key
                this.newConfirm.project_name = this.selectProject.label
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            beforeUpload(file) {
				const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				if (!isJpgOrPng) {
					this.$message.error('只能上传PNG/JPEG');
				}
				return isJpgOrPng;
			},
            handleChange(info) {
				const status = info.file.status;
				if (info.file.status === 'uploading') {
					this.uploading = true;
					return;
				}
				if (status !== 'uploading') {
				}
				if (status === 'done') {
					if (info.file.response.err == 0) {
                        this.newConfirm.attachment = []
                        for(let part of info.fileList){
                        
                            this.newConfirm.attachment.push(part.response.data);
                        }
						this.$message.success(`${info.file.name} 上传成功`);
					} else {
						this.$message.error(`${info.file.name} 上传失败`);
					}
					this.uploading = false
				} else if (status === 'error') {
				}
			},
		}
	})

</script>

<style lang="scss">
</style>